import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ValidationService, WorkflowContextService } from '../../../services';
import { Subscription } from 'rxjs';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-control-message',
  templateUrl: './control-message.component.html',
  styleUrls: ['./control-message.component.css'],
  standalone: false
})
export class ControlMessageComponent implements OnInit, OnDestroy {
  @Input() control!: UntypedFormControl;
  @Input() prefix?: string;
// added bb priya 07-01-2026
  janusErrorMessage: string | null = null;
  private subscriptions = new Subscription();
  templateForPermitForm: boolean;
 constructor(
    public layoutService: LayoutService,
  context : WorkflowContextService
 ){
    layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
}
  ngOnInit(): void {
    if (!this.control) {
      return;
    }

    this.subscriptions.add(
      this.control.valueChanges.subscribe(() => this.updateErrorMessage())
    );

    this.subscriptions.add(
      this.control.statusChanges.subscribe(() => this.updateErrorMessage())
    );

    if (this.templateForPermitForm) {
      const originalMarkAsTouched = this.control.markAsTouched.bind(this.control);
      this.control.markAsTouched = (opts?: any) => {
        originalMarkAsTouched(opts);
        this.updateErrorMessage();
      };
    }

    this.updateErrorMessage();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


private updateErrorMessage(): void {
  Promise.resolve().then(() => {

  if(this.templateForPermitForm){
    if (
      this.control &&
      typeof this.control.value === 'string' &&
      this.control.value.startsWith('0001-01-01')
    ) {
      this.control.setValue(null, { emitEvent: false });
    }
  }
      if (this.control && this.control.errors &&
          (this.control.dirty || this.control.touched)) {
        for (const propertyName in this.control.errors) {
          if (this.control.errors.hasOwnProperty(propertyName)) {
            const errorValue =
              this.control.errors[propertyName]?.data ||
              this.control.errors[propertyName];
  
            this.janusErrorMessage =
              (this.prefix || '') +
              ValidationService.getValidatorErrorMessage(
                propertyName,
                errorValue
              );
            return;
          }
        }
      }
      this.janusErrorMessage = null;
    });
  }
 //end by priya 07-01-2026

  get errorMessage() {
    // Find the control in the Host (Parent) form
    if (this.control && this.control.errors) {
      for (const propertyName in this.control.errors) {
        // If control has a error
        if (
          this.control.errors.hasOwnProperty(propertyName) &&
          (this.control.dirty || this.control.touched)
        ) {
          // Return the appropriate error message from the Validation Service
          const errors = ValidationService.getValidatorErrorMessage(
            propertyName,
            this.control.errors[propertyName].data ||
              this.control.errors[propertyName]
          );
          return (this.prefix || '') + errors;
        }
      }
    }

    return null;
  }

}
